export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Rufen Sie an, wenn Sie Fragen haben – Ihr Anruf wird vertraulich behandelt',
        subtitleInfo1: 'Bitte lesen Sie auch unsere ',
        faq: 'FAQ',
        subtitleInfo2: ', in denen Sie Antworten auf Fragen zum Hinweisgebersystem finden.',
        subtitleInfo3: '',
    }
};
